<div id='progress-current-value' [ngClass]="{ 'progress-type-0': pb.progressType === 0, 'progress-type-1': pb.progressType === 1, 'progress-type-2': pb.progressType === 2 }"></div>
